<svg
  width="18"
  height="10"
  viewBox="0 0 18 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.22489 4.3125H15.4216H16H16.5H17C17 4.3125 17.543 4.34766 17.7188 4.52344C17.8945 4.69922 18 4.91016 18 5.15625C18 5.40235 17.8945 5.61328 17.7188 5.78906C17.543 5.96485 17 6 17 6C17 6 16.8473 6 16.5 6C16.3347 6 16 6 16 6H15.4216H5.22491C4.93035 6 4.87579 4.3125 5.22489 4.3125Z"
    fill="currentColor"
  />
  <rect
    x="4.4"
    y="-0.3"
    width="3.3"
    height="3.3"
    transform="rotate(45)"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>
